import { render, staticRenderFns } from "./CreateTag.vue?vue&type=template&id=dfaa4562&scoped=true&"
import script from "./CreateTag.vue?vue&type=script&lang=js&"
export * from "./CreateTag.vue?vue&type=script&lang=js&"
import style0 from "./CreateTag.vue?vue&type=style&index=0&id=dfaa4562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaa4562",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
